import { useTranslation } from 'react-i18next';

import { P2 } from '../../../styles/FontStyles';
import { Button } from '../../../styles/GlobalComponents';
import { Icon, IconWarning } from '../../../styles/Icons';
import {
  Flex,
  FlexJustifyCenter,
  SidebarSubtitle
} from '../../../styles/stylesStyled';
import { Dispatch, SetStateAction } from 'react';

export const Warning = ({
  setStep
}: {
  setStep: Dispatch<SetStateAction<number>>;
}) => {
  const { t } = useTranslation('settings');
  return (
    <>
      <Flex>
        <Icon>
          <IconWarning color='#FCBF24' />
        </Icon>
        <P2 semiBold mb='20' ml='10' center>
          {t('email.are_you_sure')}
        </P2>
      </Flex>
      <SidebarSubtitle>
        {' '}
        {t('email.text1')}
        <br />
        <br />
        {t('email.text2')}
      </SidebarSubtitle>
      <Button onClick={() => setStep(2)}>{t('email.continue')}</Button>
    </>
  );
};
